export const SALES = 0;
export const MARKETING = 1;
export const ADMIN = 2;
export const BILLING = 4;


export const SALES_LABEL = "Sales";
export const MARKETING_LABEL = "Marketing";
export const ADMIN_LABEL = "Admin";
export const BILLING_LABEL = "Billing";
export const NOT_FOUND = "Not found";
